export function ValidarCEP(cep)
{
  var validacep = /^[0-9]{8}$/;
  if(!validacep.test(cep))
  {
    M.toast({html: "<strong class='red-text'>Informe um CEP válido</strong>", displayLength: 4000 });
    return false;
  }else{
    return true;
  }
}

export function CalcularFretePorBairroId(tarifas_entrega_bairro, bairroId)
{
  var taxa = 0.00;
  tarifas_entrega_bairro.forEach(res=>{
    if(res.bairro_id == bairroId)
      taxa = res.valor;
  })
  return taxa;
}

export function ObterBairroIdPorBairroNome(tarifas_entrega_bairro, bairroNome, cidadeNome = "")
{
  if(cidadeNome != ""){
    var id = 0;
    tarifas_entrega_bairro.forEach(res=>{
      if((res.bairro == bairroNome) && (res.cidade == cidadeNome))
        id = res.bairro_id;
    });
    return id;
  }else{
    var id = 0;
    tarifas_entrega_bairro.forEach(res=>{
      if(res.bairro == bairroNome)
        id = res.bairro_id;
    });
    return id;
  }

}

export function ObterBairroPorBairroNome(tarifas_entrega_bairro, bairroNome)
{
  var bairro = {};
  tarifas_entrega_bairro.forEach(res=>{
    if(res.bairro == bairroNome)
      bairro = res;
  });
  return bairro;
}

export function ObterBairroPorBairroId(tarifas_entrega_bairro, bairroId)
{
  var bairro = {};
  tarifas_entrega_bairro.forEach(res=>{
    if(res.bairro_id == bairroId)
      bairro = res;
  });
  return bairro;
}


export function ObterValorFretePorPeso(tarifas_entrega_peso, pesoTotalp)
{
  var valor = 0.00;
  var pesoTotal = parseFloat(pesoTotalp);

  Number.prototype.between = function(a, b) {
    var min = Math.min.apply(Math, [a, b]),
      max = Math.max.apply(Math, [a, b]);
    return this > min && this < max;
  };

  tarifas_entrega_peso.forEach(res=>{
      var peso_inicial = parseFloat(res.peso_inicial);
      var peso_final = parseFloat(res.peso_final);
      if(pesoTotal.between(peso_inicial,peso_final)){
        valor = res.valor;
      }
  });

  return valor;
}


export async function ObterEnderecoPorCep(cep)
{
  let endereco = {};
  let enderecoValido = true;

  await new Promise(done => $.getJSON("https://viacep.com.br/ws/" + cep + "/json/?callback=?", async  (dados) => {

    endereco.endereco = dados.logradouro ? dados.logradouro.substring(0, 50) : "";
    endereco.bairro = dados.bairro ? dados.bairro.substring(0, 50) : "";
    if(endereco.bairro == "")
      enderecoValido = false

    endereco.uf = dados.uf;
    if(endereco.uf == "")
      enderecoValido = false

    endereco.cep = cep;
    endereco.numero = null;
    endereco.complemento = null;
    endereco.salvo_local = false;
    endereco.cidade_nome = dados.localidade ? dados.localidade.substring(0, 50) : "";
    if(endereco.cidade_nome == "")
      enderecoValido = false

    done();
  }));

  if(!enderecoValido)
    M.toast({html: "<strong class='red-text'>Região indisponivel</strong>", displayLength: 4000 });

  return enderecoValido ? endereco : {erro:true};
}

export function ObterValorFretePorKm(tarifas_entrega_km, distancitaTotal)
{
  var valor = 0.00;
  distancitaTotal = parseFloat(distancitaTotal);
  distancitaTotal = distancitaTotal + 0.01;
  console.log("tarifas" +tarifas_entrega_km);
  Number.prototype.between = function(a, b) {
    var min = Math.min.apply(Math, [a, b]),
      max = Math.max.apply(Math, [a, b]);
    return this > min && this < max;
  };

  tarifas_entrega_km.forEach(res=>{
      var de_km = parseFloat(res.de_km);
      var ate_km = parseFloat(res.ate_km);
      if(distancitaTotal.between(de_km,ate_km)){
        if(res.is_valor_por_km){
          valor = res.valor * distancitaTotal;
        }else{
          valor = res.valor;
        }

      }
  });
  // console.log(valor)

  return valor;
}


// WEBPACK FOOTER //
// ./src/services/frete.js